import { styled } from '@mui/system';

import muiPropForwarding from 'styles/helpers/muiPropForwarding';
import { OPACITY_100, OPACITY_5 } from 'constants/opacity';
import { getHeaderAccentLightestColor } from 'styles/helpers/getThemeStyles';

function getHeroContainerOpacity(layout = 'standard', hasHeroImage = false) {
  switch (layout) {
    case 'standard':
      return hasHeroImage ? OPACITY_100 : OPACITY_5;
    default:
      return OPACITY_100;
  }
}

const HeroContainer = styled('div', {
  shouldForwardProp: muiPropForwarding('hasHeroImage', 'layout')
})(({ theme, hasHeroImage, layout = 'standard' }) => {
  return {
    opacity: getHeroContainerOpacity(layout, hasHeroImage),
    position: 'relative',
    minHeight: theme.spacing(11),
    backgroundColor: hasHeroImage
      ? theme.palette.mediumTofu
      : getHeaderAccentLightestColor(theme),
    [theme.breakpoints.up('md')]: {
      minHeight: theme.spacing(9)
    }
  };
});

export default HeroContainer;
